import { useEffect, useState } from "react";
import { useAuth } from "../utils/AuthContext";


export const useNicuInCharge = () => {
 const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const { user, loading } = useAuth();
  const [isNicuInCharge, setIsNicuInCharge] = useState(false);
  const [nicuInChargeLoading, setNicuInChargeLoading] = useState(true);

useEffect(() => {
  // console.log("useNicuInCharge User:", user);
  if (!loading) {
    if (user) {
      setIsNicuInCharge(user.role === "nicu_in_charge");
      setIsAdmin(user.role === "admin");
      setIsSuperAdmin(user.role === "superadmin");
    } else {
      setIsNicuInCharge(false);
      setIsAdmin(false);
      setIsSuperAdmin(false);
    }
    setNicuInChargeLoading(false);
  }
}, [user, loading]);

  return { isNicuInCharge, isAdmin, isSuperAdmin, isLoading: loading || nicuInChargeLoading };
};